module.exports = __webpack_public_path__ + "img/obstacle.85db138a.png";